// extracted by mini-css-extract-plugin
module.exports = {"property":"MetadataRow_property__A9aHl","value":"MetadataRow_value__2TcDV","wrapper":"MetadataRow_wrapper__1bed2"};